import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"

interface ValueTypeSelectProps {
  parameter: any
  value: any
  setFieldValue: (field: string, value: any) => void
}

export default function ValueTypeSelect({
  parameter,
  value,
  setFieldValue
}: ValueTypeSelectProps) {

  const fieldName = `${parameter.name}|${parameter.api_id}`

  return (
    <FormControl fullWidth>
      <InputLabel>{parameter.description}</InputLabel>

      <Select
        label={parameter.description}
        value={value || ""}
        onChange={(e) => {
          setFieldValue(fieldName, e.target.value)
        }}
      >
        {parameter.options?.map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}